import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

//Reducers
import companyData from './companyData';
import Assessments from './Assessments';
import PscPeerFeedback from './PscPeerFeedback'

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    companyData,
    Assessments,
    PscPeerFeedback
  });
